import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './FloatingButton.css';

const WHATSAPP_URL =
  'https://api.whatsapp.com/send?phone=5493424072977&text=Hola,%20como%20estas?%20Me%20gustar%C3%ADa%20realizar%20una%20consulta%20sobre%20sus%20servicios..';

const FloatingButton = () => {
  const location = useLocation();

  if (
    location.pathname === '/calendar' ||
    location.pathname === '/confirmation'
  ) {
    return null;
  }

  return (
    <a
      href={WHATSAPP_URL}
      className="floating-whatsapp"
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
};

export default FloatingButton;
